import { defineComponent as _defineComponent } from 'vue'
import { vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "width_wrap" }
const _hoisted_3 = { class: "body_content sub" }
const _hoisted_4 = { class: "glores-B-list-h2" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  class: "h-right",
  style: {"display":"flex","flex-direction":"column","align-items":"flex-end"}
}
const _hoisted_7 = {
  key: 0,
  class: "loading-indicator",
  style: {"text-align":"center","padding":"20px"}
}
const _hoisted_8 = {
  key: 1,
  class: "error-message",
  style: {"text-align":"center","padding":"20px","color":"red"}
}
const _hoisted_9 = {
  key: 2,
  class: "glores-B-list-type1"
}
const _hoisted_10 = { key: 1 }
const _hoisted_11 = {
  key: 0,
  class: "order-detail-modal-content",
  style: {"overflow-y":"auto","max-height":"calc(700px - 150px)","padding-right":"5px"}
}
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { style: {"width":"100%","display":"flex","justify-content":"center","gap":"10px"} }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { style: {"margin-bottom":"15px"} }
const _hoisted_16 = { style: {"width":"100%","text-align":"right"} }
const _hoisted_17 = { style: {"width":"100%","text-align":"right"} }

import { ref, onMounted, h, computed, watch } from "vue";
import MyPageSidebar from "@/views/member/MypageSidebar.vue";
import Banner from "@/components/Banner.vue";
import {
  NDataTable,
  NButton,
  NSpace,
  useMessage,
  NModal,
  NDescriptions,
  NDescriptionsItem,
  NForm,
  NFormItem,
  NInput,
  NAlert,
  FormInst,
  FormRules,
  NSelect,
  useNotification,
  NGrid,
  useDialog,
  NFormItemGi,
} from "naive-ui";
import Loading from "@/components/Loading.vue";
import { getCallable } from "@/config/env";
import * as common from "@/assets/common/common";
import * as constant from "@/constants/constant";
import { useRouter } from "vue-router";
import { ChangePassword } from "@/model/base";
import { OrgUser, Organization, OrganizationType } from "@/model/organization";
import { useAuth } from "@/composables/useAuth";
import { useActionDialog } from "@/composables/useDialog";
import { useAlertDialog } from "@/composables/useAlert";
import { USER_ROUTES } from "@/assets/route_constants";
interface UserUIData extends OrgUser {
  confirmPassword: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'OrgUser',
  setup(__props) {

const useAlert = useAlertDialog();
const { show: showActionDialog } = useActionDialog();

const notification = useNotification();
const { isLoggedIn, isOrgAdmin } = useAuth();
const dialog = useDialog();

const message = useMessage();
const router = useRouter();
watch(
  isLoggedIn,
  (newValue) => {
    if (newValue === false) {
      router.push({ name: "Home" });
    }
  },
  { immediate: true }
);

const pageLoading = ref(false);
const listLoading = ref(false);
const error = ref<string | null>(null);
const orgUsers = ref<OrgUser[]>([]);
const organizationInfo = ref<Partial<Organization> | null>(null);

const showUserDetailModal = ref(false);
const selectedUserDetail = ref<OrgUser | null>(null);
const getOrgMembersCallable = getCallable("getOrgMembers");
const deleteOrgUserMemberCallable = getCallable("deleteOrgUserMember");

// 상세 정보 수정 관련 상태
const isEditingDetail = ref(false);
const isSavingDetail = ref(false);
const editFormRef = ref<any>(null);
const updateOrgUserCallable = getCallable("updateOrgUser");
const editFormData = ref<Partial<OrgUser>>({
  orgId: "",
  uid: "",
  name: "",
  email: "",
  phoneNumber: "",
  role: "",
  position: "",
  description: "",
});

const editUserFormRules = {
  name: [
    { required: true, message: "이름을 입력해주세요", trigger: "blur" }
  ],
  email: [
    {
      type: "email",
      message: "올바른 이메일 형식이 아닙니다",
      trigger: ["input", "blur"],
    }
  ]
};


// 암호 변경 관련 상태
const showChangePasswordModal = ref(false);
const userForPasswordChange = ref<OrgUser | null>(null);
const passwordFormData = ref({
  oldPassword: "",
  newPassword: "",
  confirmNewPassword: "",
});
const passwordChangeLoading = ref(false);
const passwordChangeError = ref<string | null>(null);
const changePasswordFormRef = ref<FormInst | null>(null);
const changeOrgMemberPasswordCallable = getCallable("changeOrgUserPassword");

const showAddUserModal = ref(false);
const newUserData = ref<UserUIData>({
  uid: "",
  name: "",
  email: "",
  phoneNumber: "",
  role: "",
  position: "",
  password: "",
  confirmPassword: "",
  description: "",
});
const addUserLoading = ref(false);
const addUserError = ref<string | null>(null);
const addUserFormRef = ref<FormInst | null>(null);
const addOrgMemberCallable = getCallable("addOrgUser"); // 백엔드 함수명에 맞게 수정 필요

// 사용자 유형 선택 옵션
const userTypeOptions = [
  { label: "기관 관리자", value: "admin" },
  { label: "기관 사용자", value: "user" },
];

const columns = computed(() => [
  {
    title: "ID",
    key: "SK",
    render(row: OrgUser) {
      return row.SK.split("#").pop();
    },
    ellipsis: { tooltip: true },
  },
  { title: "이름", key: "name", ellipsis: { tooltip: true } },
  { title: "전화번호", key: "phoneNumber", ellipsis: { tooltip: true } },
  { title: "역할", key: "role", ellipsis: { tooltip: true } },
  { title: "이메일", key: "email", ellipsis: { tooltip: true } },
  {
    title: "관리",
    key: "actions",
    width: 300, // 버튼 두 개를 넣기 위해 너비 조정
    render(row: OrgUser) {
      const buttons: any[] = [];
      const userId = row.SK.split("#").pop();
      if (userId !== "admin") {
        buttons.push(
          h(
            NButton,
            {
              size: "small",
              type: "default",
              style: "margin-right: 6px;",
              onClick: () => viewUserDetails(row),
            },
            { default: () => "상세보기" }
          )
        );
        buttons.push(
          h(
            NButton,
            {
              size: "small",
              type: "default",
              style: "margin-right: 6px;",
              onClick: () => deleteUser(row),
            },
            { default: () => "삭제" }
          )
        );
        buttons.push(
          h(
            NButton,
            {
              size: "small",
              type: "primary",
              onClick: () => changePassword(row),
            },
            { default: () => "암호변경" }
          )
        );
      }
      return h(NSpace, { justify: "center" }, () => buttons); // NSpace로 버튼들을 감싸서 반환
    },
  },
]);

const pagination = ref({ pageSize: 10 }); // 페이지네이션 설정

// TODO : 사용자 추가 폼 유효성 검사 규칙
const addUserFormRules: FormRules = {
  uid: [
    {
      required: true,
      message: "사용자 ID를 입력해주세요.",
      trigger: ["input", "blur"],
    },
  ],
  name: [
    {
      required: true,
      message: "이름을 입력해주세요.",
      trigger: ["input", "blur"],
    },
  ],
  email: [
    {
      type: "email",
      message: "올바른 이메일 형식이 아닙니다.",
      trigger: ["input", "blur"],
      required: false,
    },
  ],
  type: [
    {
      required: true,
      message: "사용자 유형을 선택해주세요.",
      trigger: ["change", "blur"],
    },
  ],
  password: [
    {
      required: true,
      message: "초기 암호를 입력해주세요.",
      trigger: ["input", "blur"],
    },
    {
      min: 4,
      message: "암호는 최소 4자 이상이어야 합니다.",
      trigger: ["input", "blur"],
    }, // 예시: 최소 길이 규칙
  ],
  confirmPassword: [
    {
      required: true,
      message: "암호 확인을 입력해주세요.",
      trigger: ["input", "blur"],
    },
    {
      validator: (rule, value) => value === newUserData.value.password,
      message: "암호가 일치하지 않습니다.",
      trigger: ["input", "blur"],
    },
  ],
};
async function deleteUser(user: OrgUser) {
  const userId = user.SK.split("#").pop();
  const userName = user.name;

  showActionDialog({
    title: "사용자 삭제 확인",
    content: `정말로 사용자 '${userName}' (ID: ${userId})님을 삭제하시겠습니까? 이 작업은 되돌릴 수 없습니다.`,
    positiveText: "삭제",
    negativeText: "취소",
    confirmButtonLoadingText: "삭제 중...",
    onConfirm: async () => {
      try {
        const orgId = common.getLocalAuth().orgId;
        const result = await deleteOrgUserMemberCallable({
          orgId: orgId,
          uid: userId,
        });

        if (common.evalFunctionResult(result)) {
          notification.success({
            title: "성공",
            description: `사용자 '${userName}' (ID: ${userId})님이 성공적으로 삭제되었습니다.`,
            duration: 2500,
          });
          fetchUsers(); // 사용자 목록 새로고침
        } else {
          notification.error({
            title: "삭제 실패",
            description:
              common.getResultError(result) || "사용자 삭제에 실패했습니다.",
            duration: 3000,
          });
        }
      } catch (err: any) {
        console.error("사용자 삭제 실패:", err);
        notification.error({
          title: "오류",
          description: `사용자 삭제 중 오류 발생: ${err.message}`,
          duration: 3000,
        });
      }
    },
  });
}

async function fetchUsers() {
  listLoading.value = true;
  error.value = null;
  try {
    const result = await getOrgMembersCallable({
      orgId: common.getLocalAuth().orgId,
    });
    orgUsers.value = common.getItemListFromFunctionResult(result) as OrgUser[];
  } catch (err: any) {
    console.error("사용자 목록 로딩 실패:", err);
    error.value = "사용자 목록을 불러오는데 실패했습니다.";
    orgUsers.value = [];
  } finally {
    listLoading.value = false;
  }
}

function viewUserDetails(order: OrgUser) {
  selectedUserDetail.value = order;
  isEditingDetail.value = false;
  editFormData.value = {
    orgId: order.orgId || common.getLocalAuth().orgId,
    uid: order.SK.split("#").pop() || "",
    name: order.name || "",
    email: order.email || "",
    phoneNumber: order.phoneNumber || "",
    role: order.role || "",
    position: order.position || "",
    description: order.description || "",
  };
  showUserDetailModal.value = true;
}

async function handleSaveUserDetail() {
  try {
    await editFormRef.value?.validate();
  } catch (errors) {
    return;
  }

  dialog.warning({
    title: "주의 사항 확인",
    content: "사용자 정보를 수정하더라도 이미 이 사용자가 담당자로 지정된 기존 진단 정보(학급 정보 등)에는 자동으로 반영되지 않습니다.\n기존 진단의 담당자 정보도 함께 업데이트하려면, 해당 진단의 상세 화면에서 '담당자 변경' 기능을 사용하여 재설정해야 합니다.\n\n정말로 이대로 정보를 수정하시겠습니까?",
    positiveText: "예, 수정합니다",
    negativeText: "취소",
    onPositiveClick: async () => {
      isSavingDetail.value = true;
      try {
        const result = await updateOrgUserCallable({
          orgId: editFormData.value.orgId,
          uid: editFormData.value.uid,
          name: editFormData.value.name,
          email: editFormData.value.email || null, // 빈 문자열 대신 null
          phoneNumber: editFormData.value.phoneNumber || null,
          role: editFormData.value.role || null,
          position: editFormData.value.position || null,
          description: editFormData.value.description || null,
        });
        if (common.evalFunctionResult(result)) {
          notification.success({
            title: "성공",
            description: "사용자 정보가 성공적으로 수정되었습니다.",
            duration: 2000,
          });
          showUserDetailModal.value = false;
          fetchUsers(); // 목록 새로고침
        } else {
          notification.error({
            title: "실패",
            description: common.getResultError(result) || "사용자 정보 수정에 실패했습니다.",
            duration: 3000,
          });
        }
      } catch (err: any) {
        console.error("사용자 정보 수정 에러:", err);
        notification.error({
          title: "에러",
          description: "오류가 발생했습니다.",
          duration: 3000,
        });
      } finally {
        isSavingDetail.value = false;
      }
    }
  });
}


function changePassword(user: OrgUser) {
  userForPasswordChange.value = user;
  passwordFormData.value.oldPassword = "";
  passwordFormData.value.newPassword = "";
  passwordFormData.value.confirmNewPassword = "";
  passwordChangeError.value = null;
  showChangePasswordModal.value = true;
}

async function handlePasswordChangeSubmit() {
  if (!userForPasswordChange.value) return;

  passwordChangeError.value = null;
  if (!passwordFormData.value.newPassword) {
    passwordChangeError.value = "새 암호를 입력해주세요.";
    message.error(passwordChangeError.value);
    return;
  }
  if (
    passwordFormData.value.newPassword !==
    passwordFormData.value.confirmNewPassword
  ) {
    passwordChangeError.value = "새 암호와 암호 확인이 일치하지 않습니다.";
    message.error(passwordChangeError.value);
    return;
  }
  passwordChangeLoading.value = true;
  try {
    const userId = userForPasswordChange.value.SK.split("#").pop();
    const orgId = common.getLocalAuth().orgId;
    const param: ChangePassword = {
      orgId: orgId,
      uid: userId,
      old_password: passwordFormData.value.oldPassword,
      new_password: passwordFormData.value.newPassword,
    };
    const result = await changeOrgMemberPasswordCallable({
      orgId: orgId,
      uid: userId,
      old_password: passwordFormData.value.oldPassword,
      new_password: passwordFormData.value.newPassword,
    });
    if (common.evalFunctionResult(result)) {
      notification.success({
        title: "성공",
        description: "암호가 성공적으로 변경되었습니다.",
        duration: 2000,
      });
    } else {
      notification.error({
        title: "실패",
        description:
          common.getResultError(result) || "암호 변경에 실패했습니다.",
        duration: 2000,
      });
    }
    showChangePasswordModal.value = false;
  } catch (err: any) {
    console.error("암호 변경 실패:", err);
    passwordChangeError.value = `암호 변경에 실패했습니다: ${
      err.message || "알 수 없는 오류"
    }`;
  } finally {
    passwordChangeLoading.value = false;
  }
}

function openAddUserModal() {
  onCloseAddUserModal(); // 이전 데이터 초기화
  showAddUserModal.value = true;
}

async function handleAddUserSubmit() {
  addUserError.value = null;
  try {
    await addUserFormRef.value?.validate();
  } catch (errors) {
    return;
  }

  addUserLoading.value = true;
  try {
    const orgId = common.getLocalAuth().orgId;
    const userDataToAdd = {
      orgId: orgId,
      uid: newUserData.value.uid,
      password: newUserData.value.password,
      name: newUserData.value.name,
      email: newUserData.value.email || null, // 빈 문자열 대신 null
      phoneNumber: newUserData.value.phoneNumber || null,
      role: newUserData.value.role || null,
      position: newUserData.value.position || null,
      description: newUserData.value.description || null,
      type: newUserData.value.type,
    };

    const result = await addOrgMemberCallable(userDataToAdd);

    if (common.evalFunctionResult(result)) {
      notification.success({
        title: "성공",
        description: "사용자가 성공적으로 추가되었습니다.",
        duration: 2000,
      });
      showAddUserModal.value = false;
      fetchUsers(); // 사용자 목록 새로고침
    } else {
      addUserError.value =
        common.getResultError(result) || "사용자 추가에 실패했습니다.";
      notification.error({
        title: "실패",
        description: addUserError.value,
        duration: 3000,
      });
    }
  } catch (err: any) {
    console.error("사용자 추가 실패:", err);
    addUserError.value = `사용자 추가 중 오류가 발생했습니다: ${
      err.message || "알 수 없는 오류"
    }`;
    notification.error({
      title: "오류",
      description: addUserError.value,
      duration: 3000,
    });
  } finally {
    addUserLoading.value = false;
  }
}

function onCloseChangePasswordModal() {
  userForPasswordChange.value = null;
  passwordFormData.value.newPassword = "";
  passwordFormData.value.confirmNewPassword = "";
  passwordChangeError.value = null;
}
function onCloseAddUserModal() {
  newUserData.value = {
    id: "",
    name: "",
    email: "",
    phoneNumber: "",
    role: "",
    position: "",
    password: "",
    confirmPassword: "",
    type: "",
  };
  addUserError.value = null;
  addUserFormRef.value?.restoreValidation();
}

onMounted(async () => {
  const localAuthData = common.getLocalAuth();
  if (localAuthData) {
    if (localAuthData.org && typeof localAuthData.org === "object") {
      organizationInfo.value = localAuthData.org as Partial<Organization>;
      organizationInfo.value.uid = localAuthData.orgId;
      fetchUsers();
    } else {
      await useAlert("기관 회원전용 페이지 입니다. 로그인 후 이용해주세요.");
      router.push({ name: USER_ROUTES.Home.Name });
    }
  } else {
    await useAlert("회원전용 페이지 입니다. 로그인 후 이용해주세요.");
    router.push({ name: USER_ROUTES.Home.Name });
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createVNode(Loading, null, null, 512), [
      [_vShow, pageLoading.value]
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(MyPageSidebar),
      _createElementVNode("div", _hoisted_3, [
        _cache[34] || (_cache[34] = _createElementVNode("h1", { class: "sub_subject" }, [
          _createTextVNode("기관 사용자 관리"),
          _createElementVNode("span")
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", null, [
            (organizationInfo.value)
              ? (_openBlock(), _createBlock(_unref(NDescriptions), {
                  key: 0,
                  title: "기관 정보",
                  "label-placement": "left",
                  column: 2,
                  size: "small",
                  bordered: "",
                  class: "org-info-descriptions",
                  style: {"margin-bottom":"10px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(NDescriptionsItem), { label: "기관 ID" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(organizationInfo.value.uid || "N/A"), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(NDescriptionsItem), { label: "기관명" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(organizationInfo.value.name || "N/A"), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(NDescriptionsItem), { label: "대표자 이름" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(organizationInfo.value.president || "N/A"), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(NDescriptionsItem), { label: "기관 유형" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(common.getOrganizationTypeString(
                  organizationInfo.value.type as OrganizationType
                )), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : (!pageLoading.value && !listLoading.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createVNode(_unref(NAlert), {
                      title: "정보 없음",
                      type: "info",
                      bordered: false,
                      style: {"margin-bottom":"10px"}
                    }, {
                      default: _withCtx(() => _cache[30] || (_cache[30] = [
                        _createTextVNode(" 기관 정보를 표시할 수 없습니다. ")
                      ])),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true)
          ]),
          _cache[32] || (_cache[32] = _createElementVNode("div", { class: "h-left" }, null, -1)),
          _createElementVNode("div", _hoisted_6, [
            (_unref(isOrgAdmin))
              ? (_openBlock(), _createBlock(_unref(NButton), {
                  key: 0,
                  type: "primary",
                  onClick: openAddUserModal,
                  style: {"margin-bottom":"8px"}
                }, {
                  default: _withCtx(() => _cache[31] || (_cache[31] = [
                    _createTextVNode(" 사용자 추가 ")
                  ])),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ])
        ]),
        _cache[35] || (_cache[35] = _createElementVNode("div", null, "사용자 목록", -1)),
        (listLoading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, " 사용자 목록을 불러오는 중... "))
          : _createCommentVNode("", true),
        (error.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(error.value), 1))
          : _createCommentVNode("", true),
        (!listLoading.value && !error.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              (orgUsers.value.length > 0)
                ? (_openBlock(), _createBlock(_unref(NDataTable), {
                    key: 0,
                    columns: columns.value,
                    data: orgUsers.value,
                    pagination: pagination.value,
                    bordered: false,
                    "single-line": false
                  }, null, 8, ["columns", "data", "pagination"]))
                : (_openBlock(), _createElementBlock("ul", _hoisted_10, _cache[33] || (_cache[33] = [
                    _createElementVNode("li", { class: "none-data" }, "등록된 사용자가 없습니다.", -1)
                  ])))
            ]))
          : _createCommentVNode("", true),
        _cache[36] || (_cache[36] = _createElementVNode("div", { class: "glores-B-paginate" }, [
          _createElementVNode("div", { class: "ui-pagenate" })
        ], -1))
      ])
    ]),
    _createVNode(_unref(NModal), {
      show: showUserDetailModal.value,
      "onUpdate:show": _cache[9] || (_cache[9] = ($event: any) => ((showUserDetailModal).value = $event)),
      preset: "card",
      style: {"width":"800px","max-width":"90vw","max-height":"700px"},
      title: "사용자 상세 정보",
      bordered: true,
      closable: !isSavingDetail.value,
      "mask-closable": !isSavingDetail.value,
      onAfterLeave: _cache[10] || (_cache[10] = ($event: any) => (selectedUserDetail.value = null))
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_13, [
          (!isEditingDetail.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (_unref(isOrgAdmin))
                  ? (_openBlock(), _createBlock(_unref(NButton), {
                      key: 0,
                      type: "primary",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (isEditingDetail.value = true))
                    }, {
                      default: _withCtx(() => _cache[38] || (_cache[38] = [
                        _createTextVNode("수정")
                      ])),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_unref(NButton), {
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (showUserDetailModal.value = false))
                }, {
                  default: _withCtx(() => _cache[39] || (_cache[39] = [
                    _createTextVNode("닫기")
                  ])),
                  _: 1
                })
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createVNode(_unref(NButton), {
                  type: "primary",
                  loading: isSavingDetail.value,
                  onClick: handleSaveUserDetail
                }, {
                  default: _withCtx(() => _cache[40] || (_cache[40] = [
                    _createTextVNode("저장")
                  ])),
                  _: 1
                }, 8, ["loading"]),
                _createVNode(_unref(NButton), {
                  disabled: isSavingDetail.value,
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (isEditingDetail.value = false))
                }, {
                  default: _withCtx(() => _cache[41] || (_cache[41] = [
                    _createTextVNode("취소")
                  ])),
                  _: 1
                }, 8, ["disabled"])
              ], 64))
        ])
      ]),
      default: _withCtx(() => [
        (selectedUserDetail.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              (!isEditingDetail.value)
                ? (_openBlock(), _createBlock(_unref(NDescriptions), {
                    key: 0,
                    "label-placement": "left",
                    bordered: "",
                    column: 2,
                    size: "small"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(NDescriptionsItem), { label: "아이디" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(selectedUserDetail.value.SK.split("#").pop()), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(NDescriptionsItem), { label: "이름" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(selectedUserDetail.value.name), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(NDescriptionsItem), { label: "이메일" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(selectedUserDetail.value.email || "N/A"), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(NDescriptionsItem), { label: "전화번호" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(selectedUserDetail.value.phoneNumber || "N/A"), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(NDescriptionsItem), { label: "역할" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(selectedUserDetail.value.role || "N/A"), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(NDescriptionsItem), { label: "직책" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(selectedUserDetail.value.position || "N/A"), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(NDescriptionsItem), { label: "설명" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(selectedUserDetail.value.description || "N/A"), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createVNode(_unref(NAlert), {
                      type: "warning",
                      title: "주의 사항",
                      style: {"margin-bottom":"15px"}
                    }, {
                      default: _withCtx(() => _cache[37] || (_cache[37] = [
                        _createTextVNode(" 사용자 정보를 수정하더라도 이미 이 사용자가 담당자로 지정된 기존 진단 정보(학급 정보 등)에는 자동으로 반영되지 않습니다. 기존 진단의 담당자 정보도 함께 업데이트하려면, 해당 진단의 상세 화면에서 '담당자 변경' 기능을 사용하여 재설정해 주시기 바랍니다. ")
                      ])),
                      _: 1
                    }),
                    _createVNode(_unref(NForm), {
                      ref_key: "editFormRef",
                      ref: editFormRef,
                      model: editFormData.value,
                      rules: editUserFormRules,
                      "label-placement": "left",
                      "label-width": "80"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(NGrid), {
                          cols: 2,
                          "x-gap": 24
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(NFormItemGi), { label: "아이디" }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(NInput), {
                                  value: editFormData.value.uid,
                                  disabled: ""
                                }, null, 8, ["value"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_unref(NFormItemGi), {
                              path: "name",
                              label: "이름"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(NInput), {
                                  value: editFormData.value.name,
                                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((editFormData.value.name) = $event)),
                                  placeholder: "이름을 입력해주세요",
                                  disabled: isSavingDetail.value
                                }, null, 8, ["value", "disabled"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_unref(NFormItemGi), {
                              path: "email",
                              label: "이메일"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(NInput), {
                                  value: editFormData.value.email,
                                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((editFormData.value.email) = $event)),
                                  placeholder: "이메일을 입력해주세요",
                                  disabled: isSavingDetail.value
                                }, null, 8, ["value", "disabled"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_unref(NFormItemGi), { label: "전화번호" }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(NInput), {
                                  value: editFormData.value.phoneNumber,
                                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((editFormData.value.phoneNumber) = $event)),
                                  placeholder: "전화번호를 입력해주세요",
                                  disabled: isSavingDetail.value
                                }, null, 8, ["value", "disabled"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_unref(NFormItemGi), { label: "역할" }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(NInput), {
                                  value: editFormData.value.role,
                                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((editFormData.value.role) = $event)),
                                  placeholder: "역할을 입력해주세요 (예: 교사, 강사)",
                                  disabled: isSavingDetail.value
                                }, null, 8, ["value", "disabled"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_unref(NFormItemGi), { label: "직책" }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(NInput), {
                                  value: editFormData.value.position,
                                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((editFormData.value.position) = $event)),
                                  placeholder: "직책을 입력해주세요 (예: 담임, 주임)",
                                  disabled: isSavingDetail.value
                                }, null, 8, ["value", "disabled"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_unref(NFormItemGi), {
                              label: "설명",
                              span: "2"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(NInput), {
                                  value: editFormData.value.description,
                                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((editFormData.value.description) = $event)),
                                  type: "textarea",
                                  placeholder: "설명을 입력해주세요",
                                  disabled: isSavingDetail.value,
                                  autosize: { minRows: 2, maxRows: 4 }
                                }, null, 8, ["value", "disabled"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["model"])
                  ]))
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["show", "closable", "mask-closable"]),
    _createVNode(_unref(NModal), {
      show: showChangePasswordModal.value,
      "onUpdate:show": _cache[16] || (_cache[16] = ($event: any) => ((showChangePasswordModal).value = $event)),
      preset: "card",
      style: {"width":"500px","max-width":"90vw"},
      title: "암호 변경",
      bordered: true,
      closable: true,
      "mask-closable": false,
      onAfterLeave: onCloseChangePasswordModal
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_16, [
          _createVNode(_unref(NButton), {
            onClick: _cache[15] || (_cache[15] = ($event: any) => (showChangePasswordModal.value = false)),
            style: {"margin-right":"8px"}
          }, {
            default: _withCtx(() => _cache[42] || (_cache[42] = [
              _createTextVNode("취소")
            ])),
            _: 1
          }),
          _createVNode(_unref(NButton), {
            type: "primary",
            onClick: handlePasswordChangeSubmit,
            loading: passwordChangeLoading.value
          }, {
            default: _withCtx(() => _cache[43] || (_cache[43] = [
              _createTextVNode("변경")
            ])),
            _: 1
          }, 8, ["loading"])
        ])
      ]),
      default: _withCtx(() => [
        (userForPasswordChange.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _createElementVNode("p", _hoisted_15, [
                _createElementVNode("strong", null, _toDisplayString(userForPasswordChange.value.name), 1),
                _createTextVNode(" (" + _toDisplayString(userForPasswordChange.value.SK.split("#").pop()) + ") 님의 암호를 변경합니다. ", 1)
              ]),
              _createVNode(_unref(NForm), {
                ref_key: "changePasswordFormRef",
                ref: changePasswordFormRef,
                model: passwordFormData.value
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(NFormItem), {
                    path: "oldPassword",
                    label: "기존 암호"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(NInput), {
                        value: passwordFormData.value.oldPassword,
                        "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((passwordFormData.value.oldPassword) = $event)),
                        type: "password",
                        placeholder: "기존 암호를 입력하세요",
                        "show-password-on": "mousedown"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(NFormItem), {
                    path: "newPassword",
                    label: "새 암호"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(NInput), {
                        value: passwordFormData.value.newPassword,
                        "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((passwordFormData.value.newPassword) = $event)),
                        type: "password",
                        placeholder: "새 암호를 입력하세요",
                        "show-password-on": "mousedown"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(NFormItem), {
                    path: "confirmNewPassword",
                    label: "새 암호 확인"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(NInput), {
                        value: passwordFormData.value.confirmNewPassword,
                        "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((passwordFormData.value.confirmNewPassword) = $event)),
                        type: "password",
                        placeholder: "새 암호를 다시 입력하세요",
                        "show-password-on": "mousedown"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"]),
              (passwordChangeError.value)
                ? (_openBlock(), _createBlock(_unref(NAlert), {
                    key: 0,
                    title: "오류",
                    type: "error",
                    closable: true,
                    onClose: _cache[14] || (_cache[14] = ($event: any) => (passwordChangeError.value = null)),
                    style: {"margin-top":"10px"}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(passwordChangeError.value), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_unref(NModal), {
      show: showAddUserModal.value,
      "onUpdate:show": _cache[29] || (_cache[29] = ($event: any) => ((showAddUserModal).value = $event)),
      preset: "card",
      style: {"width":"600px","max-width":"90vw"},
      title: "신규 사용자 추가",
      bordered: true,
      closable: true,
      "mask-closable": false,
      onAfterLeave: onCloseAddUserModal
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_17, [
          _createVNode(_unref(NButton), {
            onClick: _cache[28] || (_cache[28] = ($event: any) => (showAddUserModal.value = false)),
            style: {"margin-right":"8px"}
          }, {
            default: _withCtx(() => _cache[44] || (_cache[44] = [
              _createTextVNode("취소")
            ])),
            _: 1
          }),
          _createVNode(_unref(NButton), {
            type: "primary",
            onClick: handleAddUserSubmit,
            loading: addUserLoading.value
          }, {
            default: _withCtx(() => _cache[45] || (_cache[45] = [
              _createTextVNode("추가")
            ])),
            _: 1
          }, 8, ["loading"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_unref(NForm), {
          ref_key: "addUserFormRef",
          ref: addUserFormRef,
          model: newUserData.value,
          rules: addUserFormRules
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(NGrid), {
              cols: 12,
              "x-gap": 24
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(NFormItemGi), {
                  span: 6,
                  path: "uid",
                  label: "사용자 ID"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(NInput), {
                      value: newUserData.value.uid,
                      "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((newUserData.value.uid) = $event)),
                      placeholder: "사용자 ID (로그인 시 사용)"
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createVNode(_unref(NFormItemGi), {
                  span: 6,
                  path: "name",
                  label: "이름"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(NInput), {
                      value: newUserData.value.name,
                      "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((newUserData.value.name) = $event)),
                      placeholder: "사용자 이름"
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createVNode(_unref(NFormItemGi), {
                  span: 6,
                  path: "email",
                  label: "이메일"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(NInput), {
                      value: newUserData.value.email,
                      "onUpdate:value": _cache[19] || (_cache[19] = ($event: any) => ((newUserData.value.email) = $event)),
                      placeholder: "이메일 주소 (선택)"
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createVNode(_unref(NFormItemGi), {
                  span: 6,
                  path: "phoneNumber",
                  label: "전화번호"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(NInput), {
                      value: newUserData.value.phoneNumber,
                      "onUpdate:value": _cache[20] || (_cache[20] = ($event: any) => ((newUserData.value.phoneNumber) = $event)),
                      placeholder: "전화번호 (선택)"
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createVNode(_unref(NFormItemGi), {
                  span: 4,
                  path: "role",
                  label: "역할"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(NInput), {
                      value: newUserData.value.role,
                      "onUpdate:value": _cache[21] || (_cache[21] = ($event: any) => ((newUserData.value.role) = $event)),
                      placeholder: "역할 (선택)"
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createVNode(_unref(NFormItemGi), {
                  span: 4,
                  path: "position",
                  label: "직책"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(NInput), {
                      value: newUserData.value.position,
                      "onUpdate:value": _cache[22] || (_cache[22] = ($event: any) => ((newUserData.value.position) = $event)),
                      placeholder: "직책 (선택)"
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createVNode(_unref(NFormItemGi), {
                  span: 4,
                  path: "type",
                  label: "유형"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(NSelect), {
                      value: newUserData.value.type,
                      "onUpdate:value": _cache[23] || (_cache[23] = ($event: any) => ((newUserData.value.type) = $event)),
                      placeholder: "사용자 유형 선택",
                      options: userTypeOptions
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createVNode(_unref(NFormItemGi), {
                  span: 12,
                  path: "description",
                  label: "설명"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(NInput), {
                      value: newUserData.value.description,
                      "onUpdate:value": _cache[24] || (_cache[24] = ($event: any) => ((newUserData.value.description) = $event)),
                      type: "textarea",
                      placeholder: "설명 (선택)",
                      autosize: { minRows: 2, maxRows: 4 }
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createVNode(_unref(NFormItemGi), {
                  span: 6,
                  path: "password",
                  label: "초기 암호"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(NInput), {
                      value: newUserData.value.password,
                      "onUpdate:value": _cache[25] || (_cache[25] = ($event: any) => ((newUserData.value.password) = $event)),
                      type: "password",
                      placeholder: "초기 암호 설정",
                      "show-password-on": "mousedown"
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createVNode(_unref(NFormItemGi), {
                  span: 6,
                  path: "confirmPassword",
                  label: "암호 확인"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(NInput), {
                      value: newUserData.value.confirmPassword,
                      "onUpdate:value": _cache[26] || (_cache[26] = ($event: any) => ((newUserData.value.confirmPassword) = $event)),
                      type: "password",
                      placeholder: "초기 암호 다시 입력",
                      "show-password-on": "mousedown"
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"]),
        (addUserError.value)
          ? (_openBlock(), _createBlock(_unref(NAlert), {
              key: 0,
              title: "오류",
              type: "error",
              closable: true,
              onClose: _cache[27] || (_cache[27] = ($event: any) => (addUserError.value = null)),
              style: {"margin-top":"10px"}
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(addUserError.value), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})